module.exports = __webpack_public_path__ + "img/azat2.189a4e11.jpg";